import { css } from '@emotion/react';
import type { ReactNode } from 'react';
import { LogoComponent } from '~/_shared/components/logo/logo.component';
import type { Theme } from '~/_shared/themes/theme.model';
import type { LatLng } from '~/_shared/types/latLng';

const wrapperStyle = (theme: Theme) => css({
  backgroundColor: theme.reportColors.sectionBackground,
  borderColor: theme.reportColors.borderPrimary,
  padding: '4px 16px 4px 4px',
  color: theme.reportColors.textPrimary,
  borderRadius: 4,
  boxShadow: `0px 1px 2px 0px ${theme.reportColors.boxShadow}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
});

const contentStyle = css({
  flex: 1,
});

const summaryNameStyle = css({
  fontSize: 36,
  textTransform: 'uppercase',
  margin: '12px 0',
});

const latLngStyle = (theme: Theme) => css({
  display: 'flex',
  gap: 10,
  color: theme.reportColors.textSecondary,
  fontSize: 12,
});

const headingStyle = css({
  fontWeight: 600,
  fontSize: 18,
  marginTop: 5,
});

const headingSecondaryStyle = css({
  fontSize: 14,
});

export type ExportReportSummaryProps = Readonly<{
  className?: string;
  name: string;
  latLng?: LatLng;
  heading: ReactNode;
  semiHeading?: ReactNode;
  description?: ReactNode;
}>;

export const ExportReportSummaryComponent = (props: ExportReportSummaryProps) => {
  return (
    <>
      <div css={summaryNameStyle}>{props.name}</div>

      <div css={wrapperStyle} className={props.className}>
        <div css={contentStyle}>
          {props.latLng && (
            <div css={latLngStyle}>
              <span>{`Lat: ${props.latLng.lat}`}</span>
              <span>{`Lng: ${props.latLng.lng}`}</span>
            </div>
          )}
          <div css={headingStyle}>{props.heading}</div>
          {props.semiHeading && (
            <div css={headingSecondaryStyle}>{props.semiHeading}</div>
          )}
          {props.description && (
            <div css={headingSecondaryStyle}>{props.description}</div>
          )}
        </div>

        <LogoComponent width="120px" />
      </div>
    </>
  );
};
